import SharedHostingOfferCard from './SharedHostingOfferCard'

export default SharedHostingOfferCard
